<div class="p-4">
  <app-user-profile-widget
    (userDataChange)="updateUserData($event)"
    [accountTypeNew]="accountTypeNew"
    [userAccountInformationChanged]="userAccountInformationChanged"
    (disableRadioButtons)="ondiableradionbtns($event)"
    (removeCHAPPAccountType)="onremoveCHAPPAccountType($event)"
    [isNoteSaved]="noteSaved"
  >
  </app-user-profile-widget>
</div>
<div class="px-4">
  <app-notes-account-notes [userData]="userData" (noteSaved)="isNoteSaved($event)" />
</div>
<div class="p-4">
  <app-account-information-widget
    [userId]="userId"
    [userData]="userData"
    (accountTypeNew)="onChangeAccountType($event)"
    (userAccountInformationChanged)="onUserAccountInformationChanged()"
    [disableRadioButtons] = "disableRadioButtons"
    [removeCHAPPAccountType]="removeCHAPPAccountType"
  />
</div>
<div class="p-4">
  <app-audit-log-widget [userId]="userId"></app-audit-log-widget>
</div>
